import React from 'react';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import IconChat from 'assets/customIcon/PopoverNavbarContainer/IconChat';
import { MessageCount } from './styled';
import { DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT } from './__tests__/constant';

export interface MessageIconProps {
  count: number;
}

const MessageIcon = ({ count, ...props }: MessageIconProps) => (
  <IconWrapper
    {...props}
    size="40px"
    data-cy={DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT}
    style={{ marginRight: 6 }}
  >
    <div style={{ color: '#969696', display: 'flex', alignItems: 'center' }}>
      <IconChat />
    </div>
    {count > 0 && <MessageCount>{count > 99 ? '99+' : count}</MessageCount>}
  </IconWrapper>
);

export default MessageIcon;
